import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(Alert, UserEmailsService) {
        this.Alert = Alert;
        this.UserEmailsService = UserEmailsService;
    }

    $onInit() {
        this.email = '';
    }

    save() {
        this.UserEmailsService
            .save({emailAddress: this.email}).$promise
            .then((email) => {
                this.Alert('success', 'emails.messages.email_added');
                this.close({$value: email});
            })
            .catch((error) => {
                const message = ((error || {}).data || {}).message;
                const key = message || 'emails.messages.adding_email_failed';
                this.spAlert = new SpAlert('danger', key);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/emails/add/add.controller.js